import { ILayerViewModel, ILayout } from '../models/interfaces';
import { ChangeDetectionComposer } from './changeDetectionComposer';

export class ChartSpacingComposer extends ChangeDetectionComposer<number> {
    // constructor

    constructor(layout: ILayout) {
        super(layout, 0);
    }

    public isChanged() {
        return true;
    }

    // protected functions

    protected onUpdateAll(layers: Array<ILayerViewModel>) {
        layers.sort((layerA, layerB) => {
            if (layerA.active) return -1;
            if (layerB.active) return 1;
            return 0;
        });

        layers.forEach((layer, index) => {
            layer.index = index;
        });

        const dictionaryY: Record<string, number> = {};
        const dictionaryX: Record<string, number> = {};
        const leadHeight = this.layout.context?.leadHeight ?? 0;
        const leadWidth = this.layout.context?.leadWidth ?? 0;
        this.layout.context?.layers.forEach((layer) => {
            const dncY =
                (this.layout.getLayerPosition(0).y + leadHeight) / 2 -
                (this.layout.getLayerPosition(layer.index).y + leadHeight / 2);
            const dncX =
                (this.layout.getLayerPosition(0).x + leadWidth) / 2 -
                (this.layout.getLayerPosition(layer.index).y + leadWidth / 2);
            dictionaryY[layer.title] = dncY * this.layout.ecgState.multiViewerState.studySpacing;
            dictionaryX[layer.title] = dncX * this.layout.ecgState.multiViewerState.horizontalStudySpacing;
        });

        this.layout.context?.layers.forEach((layer) => {
            const position = this.layout.getLayerPosition(layer.index);
            position.y =
                (this.layout.getLayerPosition(0).y + leadHeight) / 2 - dictionaryY[layer.title] - leadHeight / 2;
            position.x = (this.layout.getLayerPosition(0).x + leadWidth) / 2 - dictionaryX[layer.title] - leadWidth / 2;

            layer.translate =
                'translate(' +
                (Math.ceil(position.x * 5000) / 5000).toString() +
                ', ' +
                (Math.ceil(position.y * 5000) / 5000).toString() +
                ')';
        });
    }
}
